export enum FilesMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_FILES = 'SET_FILES',
  SET_BULK_FILES = 'SET_BULK_FILES',
  SET_BRAND_LIST = 'SET_BRAND_LIST',
  SET_MARKETING_MATERIALS = 'SET_MARKETING_MATERIALS',
  SET_SEARCH = 'SET_SEARCH'
}
